import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Toggle } from "@/components/Toggle/Toggle";

interface EmailSignatureSectionProps {
	value: boolean;
	onChange: (value: boolean) => void;
}

/**
 * The company's email signature setting (PREC-4401). The API reads it when a campaign email is
 * sent (`ScheduleUtilsService.processEmailStep`), and the composer's Include signature toggle
 * starts from it; the rule that keeps a signature from appearing twice is
 * `applyEmailSignature` (apps/api, schedule/utils/email-signature.util.ts).
 */
export const EmailSignatureSection: FunctionComponent<EmailSignatureSectionProps> = ({
	value,
	onChange,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`copywritingSettings.emailSignature.${key}`);

	return (
		<div className="flex flex-col gap-3">
			<label className="flex cursor-pointer items-center gap-3 text-sm text-text">
				<Toggle
					isChecked={value}
					name="appendEmailSignature"
					testId="append-email-signature-toggle"
					onChange={() => onChange(!value)}
				/>
				<span>{ts("label")}</span>
			</label>
			<p className="text-sm text-text-meta">{ts("description")}</p>
		</div>
	);
};
